// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 100%;
    max-width: 900px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modal-header {
    padding: 24px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 8px 0;
}

.modal-ticket-section {
    padding: 20px 24px;
    background-color: #f9fafb;
    text-align: left;
}

.modal-ticket-id {
    font-size: 20px;
    font-weight: 700;
    color: #4f46e5;
    margin: 0 0 12px 0;
    text-align: left;
}

.modal-description {
    font-size: 15px;
    color: #374151;
    margin: 0;
    line-height: 1.6;
    text-align: left;
}

.modal-close-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    color: #6b7280;
    border-radius: 6px;
    transition: all 0.2s;
}

.modal-close-button:hover {
    background-color: #f3f4f6;
    color: #1f2937;
}

.modal-body {
    padding: 24px;
    overflow-y: auto;
    flex: 1 1;
}

.modal-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.loader-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #e5e7eb;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.modal-loader p {
    color: #6b7280;
    font-size: 15px;
    font-weight: 500;
}

.results-section {
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.results-content {
    line-height: 1.7;
    color: #374151;
    font-size: 15px;
}

.results-content h1,
.results-content h2,
.results-content h3,
.results-content h4 {
    color: #1f2937;
    font-weight: 700;
    margin-top: 24px;
    margin-bottom: 12px;
}

.results-content h1 {
    font-size: 24px;
}

.results-content h2 {
    font-size: 20px;
}

.results-content h3 {
    font-size: 18px;
}

.results-content p {
    margin-bottom: 16px;
}

.results-content ul,
.results-content ol {
    margin-bottom: 16px;
    padding-left: 24px;
}

.results-content li {
    margin-bottom: 8px;
}

.results-content a {
    color: #4f46e5;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s;
}

.results-content a:hover {
    color: #4338ca;
    text-decoration: underline;
}

.results-content code {
    background-color: #f3f4f6;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 14px;
    font-family: 'Courier New', monospace;
}

.results-content pre {
    background-color: #1f2937;
    color: #f9fafb;
    padding: 16px;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 16px;
}

.results-content pre code {
    background: none;
    padding: 0;
    color: inherit;
}

.error-message {
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
    padding: 16px;
    border-radius: 8px;
    text-align: center;
    font-weight: 500;
}

.results-content blockquote {
    border-left: 4px solid #4f46e5;
    padding-left: 16px;
    margin: 16px 0;
    color: #6b7280;
    font-style: italic;
}

.results-content table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
}

.results-content table th,
.results-content table td {
    border: 1px solid #e5e7eb;
    padding: 8px 12px;
    text-align: left;
}

.results-content table th {
    background-color: #f9fafb;
    font-weight: 600;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .modal-content {
    background: var(--surface);
}
[data-theme="dark"] .modal-header {
    border-bottom-color: var(--border);
}
[data-theme="dark"] .modal-title,
[data-theme="dark"] .results-content h1,
[data-theme="dark"] .results-content h2,
[data-theme="dark"] .results-content h3,
[data-theme="dark"] .results-content h4 {
    color: var(--text);
}
[data-theme="dark"] .modal-ticket-section {
    background-color: var(--surface-2);
}
[data-theme="dark"] .modal-description,
[data-theme="dark"] .results-content {
    color: var(--text-muted);
}
[data-theme="dark"] .modal-close-button,
[data-theme="dark"] .modal-loader p {
    color: var(--text-muted);
}
[data-theme="dark"] .modal-close-button:hover {
    background-color: var(--surface-3);
    color: var(--text);
}
[data-theme="dark"] .results-content code {
    background-color: var(--surface-3);
    color: var(--text);
}
[data-theme="dark"] .results-content blockquote {
    color: var(--text-muted);
}
[data-theme="dark"] .results-content table th,
[data-theme="dark"] .results-content table td {
    border-color: var(--border);
    color: var(--text);
}
[data-theme="dark"] .results-content table th {
    background-color: var(--surface-2);
}

/* Mobile — desktop modal unchanged */
@media (max-width: 768px) {
    .modal-overlay {
        padding: 0;
        align-items: stretch;
    }

    .modal-content {
        max-width: none;
        width: 100%;
        max-height: 100%;
        height: 100%;
        border-radius: 0;
    }

    .modal-header,
    .modal-ticket-section,
    .modal-body {
        padding: 16px;
    }

    .modal-title {
        font-size: 1.25rem;
    }

    .modal-ticket-id {
        font-size: 1.125rem;
    }

    .results-content {
        font-size: 14px;
    }

    .results-content table {
        display: block;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchModal/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;;;;IAII,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,4DAA4D;AAC5D;IACI,0BAA0B;AAC9B;AACA;IACI,kCAAkC;AACtC;AACA;;;;;IAKI,kBAAkB;AACtB;AACA;IACI,kCAAkC;AACtC;AACA;;IAEI,wBAAwB;AAC5B;AACA;;IAEI,wBAAwB;AAC5B;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,kCAAkC;AACtC;;AAEA,qCAAqC;AACrC;IACI;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;;;QAGI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,iCAAiC;IACrC;AACJ","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 900px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n    animation: modalFadeIn 0.3s ease-out;\n}\n\n@keyframes modalFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.modal-header {\n    padding: 24px;\n    border-bottom: 1px solid #e5e7eb;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.modal-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n}\n\n.modal-ticket-section {\n    padding: 20px 24px;\n    background-color: #f9fafb;\n    text-align: left;\n}\n\n.modal-ticket-id {\n    font-size: 20px;\n    font-weight: 700;\n    color: #4f46e5;\n    margin: 0 0 12px 0;\n    text-align: left;\n}\n\n.modal-description {\n    font-size: 15px;\n    color: #374151;\n    margin: 0;\n    line-height: 1.6;\n    text-align: left;\n}\n\n.modal-close-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    color: #6b7280;\n    border-radius: 6px;\n    transition: all 0.2s;\n}\n\n.modal-close-button:hover {\n    background-color: #f3f4f6;\n    color: #1f2937;\n}\n\n.modal-body {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.modal-loader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n    text-align: center;\n}\n\n.loader-spinner {\n    width: 50px;\n    height: 50px;\n    border: 4px solid #e5e7eb;\n    border-top-color: #4f46e5;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.modal-loader p {\n    color: #6b7280;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.results-section {\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.results-content {\n    line-height: 1.7;\n    color: #374151;\n    font-size: 15px;\n}\n\n.results-content h1,\n.results-content h2,\n.results-content h3,\n.results-content h4 {\n    color: #1f2937;\n    font-weight: 700;\n    margin-top: 24px;\n    margin-bottom: 12px;\n}\n\n.results-content h1 {\n    font-size: 24px;\n}\n\n.results-content h2 {\n    font-size: 20px;\n}\n\n.results-content h3 {\n    font-size: 18px;\n}\n\n.results-content p {\n    margin-bottom: 16px;\n}\n\n.results-content ul,\n.results-content ol {\n    margin-bottom: 16px;\n    padding-left: 24px;\n}\n\n.results-content li {\n    margin-bottom: 8px;\n}\n\n.results-content a {\n    color: #4f46e5;\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s;\n}\n\n.results-content a:hover {\n    color: #4338ca;\n    text-decoration: underline;\n}\n\n.results-content code {\n    background-color: #f3f4f6;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 14px;\n    font-family: 'Courier New', monospace;\n}\n\n.results-content pre {\n    background-color: #1f2937;\n    color: #f9fafb;\n    padding: 16px;\n    border-radius: 8px;\n    overflow-x: auto;\n    margin-bottom: 16px;\n}\n\n.results-content pre code {\n    background: none;\n    padding: 0;\n    color: inherit;\n}\n\n.error-message {\n    background-color: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n    padding: 16px;\n    border-radius: 8px;\n    text-align: center;\n    font-weight: 500;\n}\n\n.results-content blockquote {\n    border-left: 4px solid #4f46e5;\n    padding-left: 16px;\n    margin: 16px 0;\n    color: #6b7280;\n    font-style: italic;\n}\n\n.results-content table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 16px;\n}\n\n.results-content table th,\n.results-content table td {\n    border: 1px solid #e5e7eb;\n    padding: 8px 12px;\n    text-align: left;\n}\n\n.results-content table th {\n    background-color: #f9fafb;\n    font-weight: 600;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .modal-content {\n    background: var(--surface);\n}\n[data-theme=\"dark\"] .modal-header {\n    border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .modal-title,\n[data-theme=\"dark\"] .results-content h1,\n[data-theme=\"dark\"] .results-content h2,\n[data-theme=\"dark\"] .results-content h3,\n[data-theme=\"dark\"] .results-content h4 {\n    color: var(--text);\n}\n[data-theme=\"dark\"] .modal-ticket-section {\n    background-color: var(--surface-2);\n}\n[data-theme=\"dark\"] .modal-description,\n[data-theme=\"dark\"] .results-content {\n    color: var(--text-muted);\n}\n[data-theme=\"dark\"] .modal-close-button,\n[data-theme=\"dark\"] .modal-loader p {\n    color: var(--text-muted);\n}\n[data-theme=\"dark\"] .modal-close-button:hover {\n    background-color: var(--surface-3);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .results-content code {\n    background-color: var(--surface-3);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .results-content blockquote {\n    color: var(--text-muted);\n}\n[data-theme=\"dark\"] .results-content table th,\n[data-theme=\"dark\"] .results-content table td {\n    border-color: var(--border);\n    color: var(--text);\n}\n[data-theme=\"dark\"] .results-content table th {\n    background-color: var(--surface-2);\n}\n\n/* Mobile — desktop modal unchanged */\n@media (max-width: 768px) {\n    .modal-overlay {\n        padding: 0;\n        align-items: stretch;\n    }\n\n    .modal-content {\n        max-width: none;\n        width: 100%;\n        max-height: 100%;\n        height: 100%;\n        border-radius: 0;\n    }\n\n    .modal-header,\n    .modal-ticket-section,\n    .modal-body {\n        padding: 16px;\n    }\n\n    .modal-title {\n        font-size: 1.25rem;\n    }\n\n    .modal-ticket-id {\n        font-size: 1.125rem;\n    }\n\n    .results-content {\n        font-size: 14px;\n    }\n\n    .results-content table {\n        display: block;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
